import React, { useState } from 'react';
import SuperAdminDashboard from './SuperAdminDashboard';
import UserManagement from './UserManagement';
import ProjectManagement from './ProjectManagement';
import SubscriptionManagement from './SubscriptionManagement';
import CountriesCurrencies from './CountriesCurrencies';
import LogsMonitoring from './LogsMonitoring';
import SuperAdminSettings from './SuperAdminSettings';
import SecurityLogs from './SecurityLogs';
import FinancingManagement from '../Admin/FinancingManagement';
import CfpDrafts from '../Admin/CfpDrafts';
import {
  ChartBarIcon,
  UserGroupIcon,
  DocumentTextIcon,
  CreditCardIcon,
  CogIcon,
  GlobeAltIcon,
  ClipboardDocumentListIcon,
  ShieldCheckIcon,
  BanknotesIcon,
  InboxArrowDownIcon
} from '@heroicons/react/24/outline';

const SuperAdmin = () => {
  const [activeTab, setActiveTab] = useState('dashboard');

  const tabs = [
    {
      id: 'dashboard',
      label: 'Tableau de bord',
      icon: ChartBarIcon,
      component: SuperAdminDashboard
    },
    {
      id: 'users',
      label: 'Utilisateurs',
      icon: UserGroupIcon,
      component: UserManagement
    },
    {
      id: 'projects',
      label: 'Projets',
      icon: DocumentTextIcon,
      component: ProjectManagement
    },
    {
      id: 'subscriptions',
      label: 'Abonnements',
      icon: CreditCardIcon,
      component: SubscriptionManagement
    },
    {
      id: 'countries',
      label: 'Pays & Devises',
      icon: GlobeAltIcon,
      component: CountriesCurrencies
    },
    {
      id: 'financing',
      label: 'Catalogue de financement',
      icon: BanknotesIcon,
      component: FinancingManagement
    },
    {
      id: 'cfp-drafts',
      label: 'Appels à valider',
      icon: InboxArrowDownIcon,
      component: CfpDrafts
    },
    {
      id: 'logs',
      label: 'Logs & Monitoring',
      icon: ClipboardDocumentListIcon,
      component: LogsMonitoring
    },
    {
      id: 'security',
      label: 'Logs de Sécurité',
      icon: ShieldCheckIcon,
      component: SecurityLogs
    },
    {
      id: 'settings',
      label: 'Paramètres',
      icon: CogIcon,
      component: SuperAdminSettings
    }
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* En-tête */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Super Administration</h1>
              <p className="mt-2 text-gray-600">
                Gestion complète de la plateforme Innovactive 360°
              </p>
            </div>
            <div className="flex items-center space-x-4">
              <div className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-medium">
                Super Admin
              </div>
            </div>
          </div>
        </div>

        {/* Navigation par onglets */}
        <div className="mb-8">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8 overflow-x-auto">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap flex items-center ${
                      activeTab === tab.id
                        ? 'border-primary text-primary'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <Icon className="h-5 w-5 mr-2" />
                    {tab.label}
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Contenu de l'onglet actif */}
        <div className="bg-white rounded-lg shadow">
          {ActiveComponent && <ActiveComponent />}
        </div>
      </div>
    </div>
  );
};

export default SuperAdmin;



